import {
  ExtranetOrderHistoryListItemDto,
  ExtranetShopOrderItemStatus,
  ExtranetShopOrderStatusEnum,
} from '@pharmac-extranet/extranet-api'
import {
  ExtranetCatalogItemChevron,
  ExtranetContainer,
  ExtranetExpandArrowColumn,
  ExtranetTableColumn,
  ExtranetTableRow,
  formatDateString,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { formatPrice } from '../../../components/physical-products/util/price-utils'
import { ShopOrderHistoryRowItems } from './ShopOrderHistoryRowItems'

export type ShopOrderHistoryRowProps = {
  order: ExtranetOrderHistoryListItemDto
}

export const ShopOrderHistoryRow = ({ order }: ShopOrderHistoryRowProps) => {
  const { maxMobile } = useBreakpoint()
  const { t } = useLanguage(['extranet', 'common'])

  const shopOrderStatuses = (
    status:
      | ExtranetShopOrderStatusEnum
      | ExtranetShopOrderItemStatus
      | 'arrived'
      | 'cancelled'
      | 'being-processed'
      | 'completed'
      | 'delivered'
      | 'partially-delivered'
      | 'sent'
  ) => {
    switch (status) {
      case ExtranetShopOrderStatusEnum.Arrived:
        return t('shop.orders.statuses.arrived')
      case ExtranetShopOrderStatusEnum.Cancelled:
        return t('shop.orders.statuses.cancelled')
      case ExtranetShopOrderStatusEnum.BeingProcessed:
        return t('shop.orders.statuses.beingProcessed')
      case ExtranetShopOrderStatusEnum.Completed:
        return t('shop.orders.statuses.completed')
      case ExtranetShopOrderItemStatus.Delivered:
        return t('shop.orders.statuses.delivered')
      case ExtranetShopOrderItemStatus.Sent:
        return t('shop.orders.statuses.sent')
      default:
        return ''
    }
  }

  return (
    <ExtranetTableRow
      key={order.orderNumber}
      expand={
        <ShopOrderHistoryRowItems
          order={order}
          statusTranslations={shopOrderStatuses}
        />
      }
      toggleExpand={() => null}
      children={({ isExpanded }) => (
        <>
          <ExtranetContainer key={`${order.orderNumber}-row`}></ExtranetContainer>
          <ExtranetTableColumn size={maxMobile ? 1 : 2}>{order.orderNumber}</ExtranetTableColumn>
          <ExtranetTableColumn size={maxMobile ? 1 : 2}>
            {formatDateString(order.orderCreatedAt)}
          </ExtranetTableColumn>
          {!maxMobile && (
            <>
              <ExtranetTableColumn size={maxMobile ? 1 : 2}>
                {shopOrderStatuses(order.orderStatus)}
              </ExtranetTableColumn>
              <ExtranetTableColumn size={maxMobile ? 1 : 2}>
                {formatPrice(order.totalSellingPrice!)}
              </ExtranetTableColumn>
              <ExtranetTableColumn size={maxMobile ? 1 : 2}>{order.purchaser}</ExtranetTableColumn>
            </>
          )}
          <ExtranetExpandArrowColumn size={1}>
            <ExtranetCatalogItemChevron isExpanded={isExpanded} />
          </ExtranetExpandArrowColumn>
        </>
      )}
    ></ExtranetTableRow>
  )
}
